import { VaultCategory, VaultFileUsageSubjectTypeEnum } from "@scrile/api-provider/dist/api/VaultsProvider";
import config from "@/config";
import { PostSubject, SortType } from "./types";

export const acceptedFiles = [
  "image",
  "video",
  "document",
  ...(config.featureAudioMessageAttachments ? ["audio"] : []),
];

// any post of the author: a file "Unused" for it is in none of the author's posts
export const ANY_POST_SUBJECT: PostSubject = {
  subjectId: "0",
  subjectType: VaultFileUsageSubjectTypeEnum.USER_CONTENT_SETS,
};

// A folder the creator made is a set of files uploaded together (photo set), it opens sorted by name: the set keeps the
// order of its file names in the folder and in "Select all" for a post. System folders (Feed) open with the most recent
// files first (CO-15592).
export const defaultSortType = (category?: VaultCategory | null): SortType =>
  category && !category.system ? SortType.FILE_NAME : SortType.LAST_USE_TIME_DESC;
